<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
  <section class="max-w-[1200px] mx-auto px-6 pt-28 pb-20">
    <header class="mb-12">
      <p class="text-sm uppercase tracking-wider text-white/60 mb-2">
        {{ type() === 'category' ? 'Category' : type() === 'tag' ? 'Tag' : 'Author' }}
      </p>
      <h1 class="text-3xl md:text-5xl font-bold text-white gradient-text">{{ displayName() }}</h1>
      <p class="text-white/70 mt-3">
        {{ filtered().length }} {{ filtered().length === 1 ? 'post' : 'posts' }}
      </p>
    </header>

    @if (allPosts().length === 0) {
      <p class="text-center text-white/70">Loading…</p>
    } @else if (filtered().length === 0) {
      <p class="text-center text-white/70">
        No posts found in this archive.
        <a class="underline" routerLink="/blog">Back to blog</a>.
      </p>
    } @else {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        @for (post of visible(); track post.id) {
          <app-blog-card [post]="post"></app-blog-card>
        }
      </div>

      @if (hasMore()) {
        <div class="flex justify-center mt-12">
          <button
            type="button"
            (click)="loadMore()"
            class="px-8 py-3 rounded-full border border-white/30 text-white hover:bg-white/10 transition">
            Load more
          </button>
        </div>
      }
    }
  </section>

  <app-connect></app-connect>
</app-background>
